<template>
  <div class="highchart-container">
    <highcharts
      :options="chartOptions"
    />
  </div>
</template>

<script>
import moment from 'moment';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

import convertToCelsius from '@shared/lib/converter/convertToCelsius';

export default {
  name: 'DailyCycleTimeGraph',
  mixins: [unitPreferencesMixin],
  props: {
    dailyStats: Array,
  },
  computed: {
    graphData() {
      const {
        partnerSettings: {
          TEMP_UNIT = '°F',
          DATE_FORMAT = 'MM-DD-YYYY',
        },
      } = this.$store.state.admin;

      const columnDate = [];
      const cycleTime = [];
      const maxOATemp = [];
      const minOATemp = [];

      this.dailyStats.forEach((c) => {
        const {
          localDate,
          avgCycleLength,
          maxTempAPI,
          minTempAPI,
        } = c;

        if (avgCycleLength) {
          const timeInMins = avgCycleLength / 60;
          cycleTime.push(timeInMins);
        } else {
          cycleTime.push(0);
        }

        let max = maxTempAPI;
        if (TEMP_UNIT === '°C') {
          max = convertToCelsius(max);
        }
        let min = minTempAPI;
        if (TEMP_UNIT === '°C') {
          min = convertToCelsius(min);
        }

        let date = moment(localDate).format('M/D/YYYY');
        if (DATE_FORMAT === 'DD-MM-YYYY') {
          date = moment(localDate).format('D/M/YYYY');
        }
        maxOATemp.push(max);
        minOATemp.push(min);
        columnDate.push(date);
      });

      return {
        columnDate,
        cycleTime,
        minOATemp,
        maxOATemp,
      };
    },
    chartOptions() {
      const {
        tempFormat,
      } = this;

      const {
        columnDate,
        cycleTime,
        minOATemp,
        maxOATemp,
      } = this.graphData;

      return {
        chart: {
          zoomType: 'x',
          height: 400,
          backgroundColor: '#0f1734',
        },
        credits: {
          enabled: false,
        },
        title: {
          text: 'Cycle Time',
          style: {
            color: 'white',
          },
        },
        tooltip: {
          useHTML: true,
          nullFormat: 'Value is not available.',
          formatter() {
            return `${this.x}<br/>`
              + `${this.series.name}: <b>${this.y.toFixed(2)}</b>`;
          },
        },
        xAxis: [{
          categories: columnDate,
          reversed: new Date(columnDate[0]) > new Date(columnDate[columnDate.length - 1]),
          title: {
            text: 'Days',
            style: {
              color: 'white',
            },
          },
          labels: {
            style: {
              color: 'white',
            },
          },
        }],
        yAxis: [{
          min: 0,
          max: Math.max(...cycleTime),
          labels: {
            format: '{value}',
            style: {
              color: 'white',
            },
          },
          title: {
            text: 'Minutes',
            style: {
              color: 'white',
            },
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: 'white',
            },
          },
        }, {
          labels: {
            format: `{value}${tempFormat}`,
            style: {
              color: 'white',
            },
          },
          title: {
            text: 'Outside Air Temperature',
            style: {
              color: 'white',
            },
          },
          min: Math.min(...minOATemp, ...maxOATemp) - 4,
          max: Math.max(...minOATemp, ...maxOATemp) + 4,
          opposite: true,
        }],
        legend: {
          itemStyle: {
            color: 'white',
          },
          shadow: false,
          align: 'center',
          verticalAlign: 'bottom',
          x: 0,
          y: 0,
        },
        series: [{
          type: 'column',
          yAxis: 0,
          xAxis: 0,
          name: 'Avg Time',
          color: '#4979FF',
          borderColor: '#4979FF',
          data: cycleTime,
        }, {
          type: 'scatter',
          yAxis: 1,
          xAxis: 0,
          name: 'Max OA T',
          color: '#FFA500',
          data: maxOATemp,
        }, {
          type: 'scatter',
          yAxis: 1,
          xAxis: 0,
          name: 'Min OA T',
          color: '#ffdb9a',
          data: minOATemp,
        }],
      };
    },
  },
};
</script>

<style lang="scss">

</style>
